import { COUNTRY_TIMEZONE_MAP } from '@cmctechnology/webinvest-constants';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone'; // import plugin
import utc from 'dayjs/plugin/utc'; // import plugin
import customParseFormat from 'dayjs/plugin/customParseFormat';

const extendDayJs = () => {
  if (!dayjs.utc) {
    dayjs.extend(utc);
  }
  if (!dayjs.tz) {
    dayjs.extend(timezone);
  }
  dayjs.extend(customParseFormat);
};

export const parseDateFromSydney = (dateStr: string, formatStr?: string) => {
  extendDayJs();
  const d = formatStr ? dayjs.tz(dateStr, formatStr, COUNTRY_TIMEZONE_MAP.AU) : dayjs.tz(dateStr, COUNTRY_TIMEZONE_MAP.AU);
  return d.toDate();
};
